// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://category-management-product-backend.onrender.com";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://kiyobackend.smartitbox.in";

export const buildApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

export { API_BASE_URL };
